import {
  allAutomationWeekdays,
  type AutomationWeekday,
} from "@repo/app-types/entities/automation";
import {
  ToggleChipGroup,
  type ToggleChipOption,
} from "@repo/ui/toggleButton/toggleChipGroup";
import type { FC } from "react";

const weekdayShortLabels: Record<AutomationWeekday, string> = {
  monday: "Mon",
  tuesday: "Tue",
  wednesday: "Wed",
  thursday: "Thu",
  friday: "Fri",
  saturday: "Sat",
  sunday: "Sun",
};

const weekdayOptions: readonly ToggleChipOption<AutomationWeekday>[] =
  allAutomationWeekdays.map((weekday) => ({
    id: weekday,
    label: weekdayShortLabels[weekday],
  }));

interface WeekdayTogglesProps {
  value: readonly AutomationWeekday[];
  onChange: (weekdays: readonly AutomationWeekday[]) => void;
  isDisabled?: boolean;
}

/**
 * A compact chip row for picking one or more weekdays. Renders the shared
 * {@link ToggleChipGroup}; the "at least one" rule is enforced here because the
 * custom agent's weekly schema requires a non-empty weekday set.
 */
export const WeekdayToggles: FC<WeekdayTogglesProps> = ({
  value,
  onChange,
  isDisabled,
}) => {
  return (
    <ToggleChipGroup
      aria-label="Run days"
      options={weekdayOptions}
      value={value}
      isDisabled={isDisabled}
      onChange={(weekdays) => {
        // Ignore a deselection that would empty the set.
        if (weekdays.length > 0) {
          onChange(weekdays);
        }
      }}
    />
  );
};
